import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-6">
  <div className="max-w-7xl mx-auto px-6 flex justify-center items-center">
    <p>&copy; 2026 AlphaQ. All Rights Reserved.</p>
  </div>
</footer>
  );
};

export default Footer;
